/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringIdAndLabel
 */
export interface StringIdAndLabel {
    /**
     * 
     * @type {string}
     * @memberof StringIdAndLabel
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringIdAndLabel
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringIdAndLabel
     */
    effective?: boolean;
}

export function StringIdAndLabelFromJSON(json: any): StringIdAndLabel {
    return StringIdAndLabelFromJSONTyped(json, false);
}

export function StringIdAndLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringIdAndLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
    };
}

export function StringIdAndLabelToJSON(value?: StringIdAndLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'effective': value.effective,
    };
}


